import { cn } from "@/lib/utils";
import type { LucideIcon } from "lucide-react";

export function StatCard({
  label,
  value,
  icon: Icon,
  hint,
  accent = "primary",
  loading = false,
}: {
  label: string;
  value: number | string;
  icon: LucideIcon;
  hint?: string | undefined;
  accent?: "primary" | "rose" | "info" | "success" | undefined;
  loading?: boolean | undefined;
}) {
  const accents = {
    primary: "bg-primary/8 text-primary",
    rose: "bg-rose/15 text-rose",
    info: "bg-info/10 text-info",
    success: "bg-success/10 text-success",
  } as const;

  return (
    <div className="card-surface hover-lift p-5 sm:p-6">
      <div className="flex items-start justify-between gap-3">
        <p className="text-xs font-semibold tracking-wider text-muted-foreground uppercase">
          {label}
        </p>
        <span className={cn("grid size-9 place-items-center rounded-xl", accents[accent])}>
          <Icon className="size-4" />
        </span>
      </div>
      {loading ? (
        <div className="mt-4 h-9 w-16 animate-pulse rounded-lg bg-muted" />
      ) : (
        <p className="mt-3 font-display text-4xl leading-none font-semibold tabular-nums">
          {value}
        </p>
      )}
      {hint && <p className="mt-2 text-xs text-muted-foreground">{hint}</p>}
    </div>
  );
}
